import React, { useState, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Button } from "pepsico-ds";
import { useSelector } from "react-redux";
import DataTable from "./DataTable";
import { TableWrapper } from "./style";
import { CURATOR_PAGE_API_CONSTANT } from "../../../constant/constant";
import { curatorCSVFileDownload } from "../../../utils/function";
import CustomCuratorFilter from "../CustomCuratorFilter";
import downloadIcon from "../../../assets/download_icon.png";
import useThemeRender from "../../../theme/useThemeRender";

const ArtifactHistory = ({ pageName, Tabledata, loading ,refreshData}) => {
  const isDarkTheme = useSelector((state) => state.theme);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [pageData, setPageData] = useState([]);
  const serachText = useSelector((state) => state.curatorPageLookUpData).search;
  const [filterValue, setFilterValue] = useState({
    contentType: null,
    visibility: null,
    contentLevel: null,
  });
  const curatorPageLookUpData = useSelector((state) => state.internalFilter);
  useEffect(() => {
    setPageData(Tabledata);
  }, [Tabledata]);

  useEffect(() => {
    let filteredArray = [...Tabledata];
    if (filterValue?.contentLevel !== null) {
      filteredArray = filteredArray?.filter((currentRow) =>
        currentRow?.level?.includes(filterValue.contentLevel)
      );
    }
    if (filterValue?.visibility !== null) {
      filteredArray = filteredArray?.filter((currentRow) =>
        currentRow?.visibility?.includes(filterValue.visibility)
      );
    }
    if (filterValue?.contentType !== null) {
      filteredArray = filteredArray?.filter((currentRow) =>
        currentRow?.type?.includes(filterValue.contentType.toUpperCase())
      );
    }
    if (
      filterValue?.contentType === null &&
      filterValue?.visibility === null &&
      filterValue?.contentLevel === null
    ) {
      setPageData(Tabledata);
    } else {
      setPageData(filteredArray);
    }
  }, [filterValue]);

  const updatedFilterValue = (value, type) => {
    setFilterValue((preState) => {
      return {
        ...preState,
        [type]: value === undefined ? null : value,
      };
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        paddingBottom: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: "8px",
          gap: "8px",
          alignItems: "center",
          alignSelf: "stretch",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <CustomCuratorFilter
            pageName={CURATOR_PAGE_API_CONSTANT.artificat_history}
            filters={curatorPageLookUpData}
            updatedFilterValue={updatedFilterValue}
            filterValue={filterValue}
          />
        </Box>
        <Button
          text="Export"
          size="medium"
          onClick={() => curatorCSVFileDownload(pageData, pageName)}
          isDark={isDarkTheme}
        />
      </Box>

      <Box
        sx={{
          height: "100%",
          padding: "16px",
          background: useThemeRender("cardBackgroundColorLayer1"),
        }}
      >
        <TableWrapper isMobile={isMobile} isDarkTheme={isDarkTheme}>
          <DataTable
            pageName={pageName}
            Tabledata={pageData}
            serachText={serachText}
            loading={loading}
            refreshData={refreshData}
          />
        </TableWrapper>
      </Box>
    </Box>
  );
};

export default ArtifactHistory;
